<template>
    <div class="main-body">
        <div class="header">仓库列表</div>
        <div class="out">

            <div class="search2">

                <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

                <div style="float:right">
                    <el-input  placeholder="请输入仓库名称" v-model="name" clearable @change="getList" style="width:200px"></el-input>
                    <el-select
                        v-model="status"
                        style="margin:0 10px;width:200px"
                        placeholder="请选择入住状态">
                        <el-option
                            v-for="(item,i) in statusValue"
                            :key="i"
                            :label="item"
                            :value="i">
                        </el-option>
                    </el-select>
                    <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
                </div>

                <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" :data="tableData" v-loading="loading" :height="th" border style="width: 100%;" highlight-current-row @row-click='rowClick'>

                <el-table-column prop="name" label="名称"></el-table-column>

                <el-table-column prop="sort" label="排序"></el-table-column>

                <el-table-column prop="Status" :formatter="statusTitle" label="状态"></el-table-column>


              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                </template>
              </el-table-column>

            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
        <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import Edit from "./Edit";
    import Add from "./Add";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                disabledAdd:true,
                menuButtonList:null,
                disabledEdit:true,
                row:null,
                showModalAdd:false,
                showModalEdit:false,
                tableData:null,
                status:0,
                statusValue:['仓库状态','正常','禁用'],
                totalItems: 0,
                name: '',
                pageSize:20,
                currentPage:1,
                th:0,

            }
        },
        components:{
            Add,Edit
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{

            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },

          handleEdit(index, row) {
            this.$refs.myEdit.init(row);
            this.showModalEdit = !this.showModalEdit;
          },
          closeEdit:function(){
            this.showModalEdit = !this.showModalEdit;
          },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },

            getList(){
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Warehouse/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        name:this.name,
                        status:this.status-1,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading=false;
                    this.disabledEdit=true;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row){
                if(row.status == 0){
                    return "正常";
                }
                if(row.status == 1){
                    return "禁用";
                }
                return "其它";
            },


        }
    }
</script>

<style lang='scss' scoped>
/deep/ .el-table__body tr.current-row>td {
        background: rgb(121, 187, 255);
        color:#fff;
    }
</style>
